<template>
  <at-widget-booking
    v-bind="$attrs"
    :tab="tab"
    :is-admin="isAdmin ? 'true' : 'false'"
    :is-personal="isPersonal ? 'true' : 'false'"
  />
</template>

<script>
import { useModernWidget } from './useWidget'

export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },

    isPersonal: {
      type: Boolean,
      default: false,
    },

    hiddenRideTypes: {
      type: Array,
      required: true,
    },

    selectedTab: {
      type: String,
      required: true,
    },

    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      widget: null,
    }
  },

  computed: {
    tab() {
      if (this.selectedTab === 'cityTaxi') {
        return 'city_taxi'
      }

      return this.selectedTab
    },
  },

  watch: {
    user() {
      this.updateWidgetState()
    },
  },

  mounted() {
    useModernWidget().then(([widget, destroy]) => {
      this.widget = widget
      this.$once('hook:beforeDestroy', destroy)
      this.onReady()
    })
  },

  methods: {
    onReady() {
      this.updateWidgetState()

      this.$emit('ready')
    },
    updateWidgetState() {
      // on widget ready reset widget store to initial state
      // todo: inspect why we need reset widget state
      this.widget.config.globalProperties.$api.resetInitialStore()
      this.widget.config.globalProperties.$api.setLocaleLoaded(true)
      if (this.isAdmin) {
        this.widget.config.globalProperties.$api.setAdminSelectedUser(this.user)
      }
      if (this.isPersonal) {
        this.widget.config.globalProperties.$api.setAccount(this.user)
      }
      this.widget.config.globalProperties.$api.setSelectedTab(this.tab)
      this.widget.config.globalProperties.$api.setHiddenRideTypes(
        this.hiddenRideTypes
      )
    },
  },
}
</script>
